import React, { useMemo } from "react";

import { UnauthenticatedPage } from "Components/Pages/UnauthenticatedPage";
import { observer } from "mobx-react";
import { useAuth } from "Shared/Hooks";
import { M365PulseLink } from "Shared/Components";

const LoginErrorPageBase = () => {
    const { authError } = useAuth();

    const content = useMemo(
        () => (
            <>
                <h2>Sign in failed</h2>
                <p>Error: {JSON.stringify(authError)}</p>
                <M365PulseLink path="login">Click here to sign in again</M365PulseLink>
            </>
        ),
        [authError]
    );

    return <UnauthenticatedPage content={content} />;
};

export const LoginErrorPage = observer(LoginErrorPageBase);
